import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import Config from "../utils/Config";
import "./ManageDealershipSelector.css";

export default function ManageDealershipSelector({ claimId, currentName, hasUnsavedChanges, disabled, onSwitch }) {
  const { user } = useContext(AuthContext);
  const [claims, setClaims] = useState([]);
  const [error, setError] = useState(false);
  const [pending, setPending] = useState(null);
  const selectRef = useRef(null);
  const stayRef = useRef(null);
  useEffect(() => {
    const controller = new AbortController();
    let current = true;
    setClaims([]); setError(false);
    (async () => {
      try {
        const res = await fetch(`${Config.API.API_BASE_URL}${Config.ENDPOINTS.DEALERS_MY_FFLS_BY_STATUS}?status=${encodeURIComponent("Pending,Approved,Live")}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }, signal: controller.signal });
        const data = await res.json();
        if (!res.ok || !Array.isArray(data)) throw new Error("Unavailable");
        if (current) setClaims(data.filter(claim => claim && typeof claim._id === "string"));
      } catch { if (current) setError(true); }
    })();
    return () => { current = false; controller.abort(); };
  }, [user?.id, user?._id]);
  useEffect(() => { if (pending) stayRef.current?.focus(); }, [pending]);
  const stay = () => { setPending(null); selectRef.current?.focus(); };
  return <div className="manage-dealership-switcher">
    <label htmlFor="manage-dealership-select">Dealership</label>
    <select id="manage-dealership-select" ref={selectRef} value={String(claimId)} disabled={disabled || !claims.length}
      onChange={event => {
        const claim = claims.find(item => item._id === event.target.value);
        if (!claim || claim._id === String(claimId)) return;
        if (hasUnsavedChanges) setPending(claim); else onSwitch(claim);
      }}>
      {!claims.some(claim => claim._id === String(claimId)) && <option value={String(claimId)}>{currentName || "Current dealership"}</option>}
      {claims.map(claim => <option key={claim._id} value={claim._id}>{claim.businessName || claim.fflName || claim.subdomain || "Dealership"}</option>)}
    </select>
    {error && <small role="status">Unable to load your dealerships. You can continue editing this dealership.</small>}
    {pending && <div className="modal-overlay" onKeyDown={event => {
      if (event.key === "Escape") { event.preventDefault(); stay(); }
      if (event.key === "Tab") {
        const buttons = event.currentTarget.querySelectorAll("button");
        if (event.shiftKey && document.activeElement === buttons[0]) { event.preventDefault(); buttons[1].focus(); }
        else if (!event.shiftKey && document.activeElement === buttons[1]) { event.preventDefault(); buttons[0].focus(); }
      }
    }}><div className="modal" role="dialog" aria-modal="true" aria-labelledby="dealership-switch-title" aria-describedby="dealership-switch-message">
      <h3 id="dealership-switch-title">Switch Dealership</h3>
      <p id="dealership-switch-message">You have unsaved changes. Switching dealerships will discard them. Continue?</p>
      <div className="modal-buttons">
        <button ref={stayRef} type="button" className="cancel-delete" onClick={stay}>Stay Here</button>
        <button type="button" className="confirm-delete" onClick={() => { const claim = pending; setPending(null); onSwitch(claim); }}>Switch Dealership</button>
      </div>
    </div></div>}
  </div>;
}
